var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      staticClass: "modal-common",
      attrs: {
        "cover-closeable": false,
        "show-close": false,
        "show-back": false,
        "not-shadow": true,
        name: _vm.modalName
      },
      on: { modalClose: _vm.handleClose }
    },
    [
      _vm.commonType === "notstart"
        ? _c(
            "div",
            {
              staticClass: "act notstart",
              attrs: { slot: "modal-content" },
              slot: "modal-content"
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v("活动还未开始，敬请期待")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.commonType === "ended"
        ? _c(
            "div",
            {
              staticClass: "act ended",
              attrs: { slot: "modal-content" },
              slot: "modal-content"
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v("活动已结束，下次早点来哦~")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.commonType === "offline"
        ? _c(
            "div",
            {
              staticClass: "act offline",
              attrs: { slot: "modal-content" },
              slot: "modal-content"
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v("活动已下线，下次早点来哦~")
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }